import dayjs from 'dayjs';

export const days = ['S', 'M', 'T', 'W', 'T', 'F', 'S'];

export function getWeekday (date) {
  return new Date(date).getDay();
}

export function getNumberOfDaysInMonth (year, month) {
  return dayjs(`${year}-${month}-01`).daysInMonth();
}

export function createDaysForPreviousMonth (currentMonthDays, month, year) {
  const previousMonth = dayjs(`${year}-${month}-01`).subtract(1, 'month');
  const previousDates = [];
  const startOfWeek = dayjs(`${year}-${month}-01`).startOf('month').format('d');
  for (let i = startOfWeek - 1; i >= 0; i--) {
    const date = dayjs(previousMonth).endOf('month').subtract(i, 'day');
    previousDates.push({
      date           : date.format('YYYY-MM-DD'),
      dayOfMonth     : +date.format('DD'),
      isCurrentMonth : false,
    });
  }

  return previousDates;
}

export function createDaysForNextMonth (
  month,
  year,
  monthDays
) {
  const nextMonth = dayjs(`${year}-${month}-01`).add(1, 'month');

  const remainingDaysToFill = 42 - monthDays.length;
  const nextMonthDates = [];
  for (let i = 0; i < remainingDaysToFill; i++) {
    const date = dayjs(nextMonth).add(i, 'day');
    nextMonthDates.push({
      date           : date.format('YYYY-MM-DD'),
      dayOfMonth     : +date.format('DD'),
      isCurrentMonth : false,
    });
  }

  return nextMonthDates;
}

export function createDaysForCurrentMonth (year, month) {
  return [...Array(getNumberOfDaysInMonth(year, month))].map((day, index) => {
    return {
      date           : dayjs(`${year}-${month}-${index + 1}`).format('YYYY-MM-DD'),
      dayOfMonth     : index + 1,
      isCurrentMonth : true,
    };
  });
}
